import React from 'react';
import PropTypes from 'prop-types';
import styles from './BillingDataCard.css';
import { SimpleButton } from '../../../../common/simple-button/SimpleButton';
import { BILLING_DATA_TYPES } from '../../../../models/BillingData';

const IPropTypes = {
  billing: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    address: PropTypes.string,
    rut: PropTypes.string,
    personalId: PropTypes.string,
    locality: PropTypes.string,
    department: PropTypes.string,
  }).isRequired,
  toogleEditClick: PropTypes.func.isRequired,
};

const BillingDataCard = props => (
  <div className={styles.container}>
    <input
      className={styles.name}
      value={props.billing.name}
      type="text"
      name="name"
      readOnly
    />
    <input
      className={styles.address}
      value={props.billing.address}
      type="text"
      name="address"
      readOnly
    />
    <input
      className={styles.localityDepartment}
      value={`${props.billing.locality}, ${props.billing.department}`}
      type="text"
      name="localityDepartment"
      readOnly
    />
    {
      props.billing.type === BILLING_DATA_TYPES.RUT &&
      <input
        className={styles.rutOrPersonalId}
        value={`RUT: ${props.billing.rut}`}
        type="text"
        name="rut"
        readOnly
      />
    }
    {
      props.billing.type !== BILLING_DATA_TYPES.RUT &&
      <input
        className={styles.rutOrPersonalId}
        value={`CI: ${props.billing.personalId}`}
        type="text"
        name="personalId"
        readOnly
      />
    }
    <SimpleButton
      className={styles.editBillingData}
      onClick={() => props.toogleEditClick(props.billing)}
    >
      Editar
    </SimpleButton>
  </div>
);

BillingDataCard.propTypes = IPropTypes;

export { BillingDataCard };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-billing-data/billing-data-card/BillingDataCard.jsx